"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
var _utils = require("../HoursOfOperation/utils");
var _AllOrOne = _interopRequireDefault(require("../../AllOrOne"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var ABBREVIATED_DAYS = {
  monday: 'mon',
  tuesday: 'tue',
  wednesday: 'wed',
  thursday: 'thu',
  friday: 'fri',
  saturday: 'sat',
  sunday: 'sun'
};
var getHours = function getHours(dayOfWeek) {
  var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var closedText = arguments.length > 2 ? arguments[2] : undefined;
  var startTimeKey = arguments.length > 3 ? arguments[3] : undefined;
  var endTimeKey = arguments.length > 4 ? arguments[4] : undefined;
  var openDay = hours[dayOfWeek];
  var openClose = /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-half"
  }, closedText);
  if (openDay !== undefined) {
    openClose = openDay.map(function (v) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-half",
        id: (0, _lodash.uniqueId)("".concat(dayOfWeek, "-hours-")),
        key: (0, _lodash.uniqueId)(dayOfWeek)
      }, (0, _utils.formatTimeOfDay)(v[startTimeKey]), " - ", (0, _utils.formatTimeOfDay)(v[endTimeKey]));
    });
  }
  return openClose;
};
var HoursOfOperationToday = function HoursOfOperationToday(_ref) {
  var hours = _ref.hours,
    showAll = _ref.showAll,
    showToggle = _ref.showToggle,
    shouldStartWeekToday = _ref.shouldStartWeekToday,
    abbreviateDays = _ref.abbreviateDays,
    closedText = _ref.closedText,
    startTimeKey = _ref.startTimeKey,
    endTimeKey = _ref.endTimeKey;
  var todayIndex = shouldStartWeekToday ? (0, _moment["default"])().day() : 1; // today or monday
  var weekFromToday = [].concat(_toConsumableArray((0, _lodash.slice)(_constants.DAYS_OF_THE_WEEK, todayIndex)), _toConsumableArray((0, _lodash.slice)(_constants.DAYS_OF_THE_WEEK, 0, todayIndex)));
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAllHours = _useState2[0],
    setshowAllHours = _useState2[1];
  var hoursOfOperationClass = function hoursOfOperationClass() {
    return (0, _classnames["default"])({
      'ui-hours-of-operation-today': true,
      'ui-hours-of-operation-today--today-only': !showAll
    });
  };
  var hoursToggleClass = function hoursToggleClass() {
    return (0, _classnames["default"])({
      'ui-hours-of-operation-day flex items-start': true,
      'ui-hours-of-operation-day--link': shouldStartWeekToday && showAll
    });
  };
  var hoursDayLabel = function hoursDayLabel() {
    return (0, _classnames["default"])({
      'ui-hours-of-operation-day__day-label mr-4 capitalize inline-block': true,
      'w-auto': !showAllHours && showToggle
    }, abbreviateDays ? 'w-8' : 'w-20');
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: hoursOfOperationClass(),
    "data-test-element": "hours-of-operation"
  }, /*#__PURE__*/_react["default"].createElement(_AllOrOne["default"], {
    showAll: showToggle ? showAll && showAllHours : showAll
  }, weekFromToday.map(function (dayOfWeek) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      _react["default"].createElement("div", {
        className: hoursToggleClass(),
        key: (0, _lodash.uniqueId)(dayOfWeek),
        onClick: showToggle ? function () {
          return setshowAllHours(!showAllHours);
        } : null,
        role: showToggle ? 'button' : ''
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: hoursDayLabel()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: (0, _lodash.uniqueId)(dayOfWeek)
      }, abbreviateDays ? ABBREVIATED_DAYS[dayOfWeek] : dayOfWeek)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-hours-of-operation-day__hours inline-block"
      }, getHours(dayOfWeek, hours, closedText, startTimeKey, endTimeKey)), showToggle && showAll && _constants.DAYS_OF_THE_WEEK[todayIndex] === dayOfWeek && /*#__PURE__*/_react["default"].createElement("span", {
        className: "ui-hours-of-operation-day__toggle ml-half inline-flex items-baseline"
      }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
        color: "#4467AB" // should always match link-color (tw: current-blue)
        ,
        icon: showAllHours ? 'IconCaretUp' : 'IconCaretDown'
      })))
    );
  })));
};
HoursOfOperationToday.propTypes = {
  /** hours of operation values to display */
  hours: _propTypes["default"].object,
  /** should display all days or only the first one */
  showAll: _propTypes["default"].bool,
  /** should display a separate caret to individually toggle hours */
  showToggle: _propTypes["default"].bool,
  /** should start the days of the week on current day */
  shouldStartWeekToday: _propTypes["default"].bool,
  /** show abbreviated day labels instead of full day (i.e. `Mon` vs `Monday`) */
  abbreviateDays: _propTypes["default"].bool,
  /** text to display when given day has no hours associated */
  closedText: _propTypes["default"].string,
  /** key for start time in hours object (`{ monday: { opens: '09:00', closes: '17:00' } }`) */
  startTimeKey: _propTypes["default"].string,
  /** key for end time in hours object (`{ monday: { opens: '09:00', closes: '17:00' } }`) */
  endTimeKey: _propTypes["default"].string
};
HoursOfOperationToday.defaultProps = {
  hours: {},
  showAll: true,
  showToggle: false,
  shouldStartWeekToday: true,
  abbreviateDays: true,
  closedText: _constants.CLOSED_DAY,
  startTimeKey: 'opens',
  endTimeKey: 'closes'
};
var _default = exports["default"] = HoursOfOperationToday;